import React, { ReactChild } from "react";

import { makeStyles } from "tss-react/mui";
import { Grid, Button, Typography, Link as MuiLink } from "@mui/material";

import { Link, LinkProps } from "react-router-dom";
import WhitelabelLogo from "../admin/WhitelabelLogo";

const useStyles = makeStyles()((theme) => ({
  main: {
    background: theme.palette.backgrounds.pageGradient,
    padding: theme.spacing(10, 4),
    flex: 1,
    gridColumn: "span 1",
    gridRow: "1 / span 3",
    
  },
  header: {
    "&& > h1": {
      marginBottom: theme.spacing(2),
    },
  },
  children: {
    marginBottom: theme.spacing(4),
  },
  anchor: {
    alignSelf: "center",
  },
}));

export const PageFrame = ({
  centerText,
  title,
  subtitle,
  children,
  buttonData,
  anchorData,
  buttonAnchor,
}: PageFrameProps) => {
  const { classes } = useStyles();

  return (
    <Grid
      container
      component="main"
      direction="column"
      wrap="nowrap"
      className={classes.main}
      justifyContent="space-between"
    >
      <Grid container item justifyContent="center">
        <WhitelabelLogo />
      </Grid>
      <div className={classes.header}>
        <Typography
          align={centerText ? "center" : "left"}
          variant="h2"
          component="h1"
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography align={centerText ? "center" : "left"} variant="body1">
            {subtitle}
          </Typography>
        )}
      </div>

      {children && (
        <Grid className={classes.children} justifyContent="center">
          {children}
        </Grid>
      )}
      {buttonData && (
        <Button
          variant="contained"
          color="primary"
          {...buttonData}
        >
          {buttonData.text}
        </Button>
      )}

      {buttonAnchor && (
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to={buttonAnchor.to}
        >
          {buttonAnchor.text}
        </Button>
      )}


      {anchorData && (
        <Typography className={classes.anchor}>
          {anchorData.prefix ? `${anchorData.prefix} ` : null}
          <MuiLink
            component={Link}
            to={anchorData.to}
            variant="body1"
            underline="always"
          >
            {anchorData.text}
          </MuiLink>
        </Typography>
      )}
    </Grid>
  );
};

export type PageFrameProps = {
  /** Main title of the page */
  title: string;
  /** Text to be displayed right under the title */
  subtitle?: string;
  /** If true, the Typography's will receive `align: center` */
  centerText?: boolean;
  /** Config in case button is displayed */
  buttonData?: {
    text: string | ReactChild;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean,
  };
  /** Config for pages that end with links */
  anchorData?: {
    /** Clickable anchor text */
    text: string;
    /** \Acceps anything allowed by react-router's `to` */
    to: LinkProps["to"];
    /** Non-clickable text to be displayed BEFORE the link */
    prefix?: string;
  };
  /** In case the button performs a navigation */
  buttonAnchor?: {
    /** Displayed inside the button */
    text: string;
    /** Accepts anything allowed by react-router's `to` */
    to: LinkProps["to"];
  };
  children?: any; // MUI won't let me be more specific
};
